module.exports = __webpack_public_path__ + "img/red_plane.2d94e541.svg";